/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_MarkersInputs */

const en_project_markers = /** @type {(inputs: Project_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Project Markers`)
};

const fr_project_markers = /** @type {(inputs: Project_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marqueurs du projet`)
};

const de_project_markers = /** @type {(inputs: Project_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projektmarkierungen`)
};

const it_project_markers = /** @type {(inputs: Project_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indicatori di progetto`)
};

const ru_project_markers = /** @type {(inputs: Project_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Маркеры проекта`)
};

const es_project_markers = /** @type {(inputs: Project_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcadores de proyecto`)
};

const zh_cn2_project_markers = /** @type {(inputs: Project_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项目标记`)
};

const ja_project_markers = /** @type {(inputs: Project_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトマーカー`)
};

const hi_project_markers = /** @type {(inputs: Project_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परियोजना मार्कर`)
};

const pt_pt2_project_markers = /** @type {(inputs: Project_MarkersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcadores de projeto`)
};

/**
* | output |
* | --- |
* | "Project Markers" |
*
* @param {Project_MarkersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_markers = /** @type {((inputs?: Project_MarkersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_MarkersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_project_markers(inputs)
	if (locale === "de") return de_project_markers(inputs)
	if (locale === "it") return it_project_markers(inputs)
	if (locale === "ru") return ru_project_markers(inputs)
	if (locale === "es") return es_project_markers(inputs)
	if (locale === "zh-CN") return zh_cn2_project_markers(inputs)
	if (locale === "ja") return ja_project_markers(inputs)
	if (locale === "hi") return hi_project_markers(inputs)
	if (locale === "pt-PT") return pt_pt2_project_markers(inputs)
	return en_project_markers(inputs)
});